import React, { useRef, useEffect, useState } from "react";
import styles from "./ReviewSavedMain.module.css";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { useHistory, Link, useParams } from "react-router-dom";

import Radio from "@material-ui/core/Radio";
import document from "../../../assets/images/document.svg";

import { ApplicationByIdApi } from "../../../config/ApplicationByIdApi";
import { submitDetailsApi } from "../../../config/submitDetailsApi";
import { ApplicationByFormId } from "../../../config/ApplicationByFormId";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";
import changeDetails from "../../../store/Actions/DetailsAction";

function ReviewSavedMain(props) {
  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }
      setToken(item.value.token);





      const application = async (token) => {
        const getApplication = await ApplicationByIdApi(
          token,
          props.passportDetails.id
        );

        if (getApplication.data) {
          (getApplication.data.data.travellers_informations).map((value, index)=>{
            if(value.id === props.form){
              console.log(value)
              setDocs(value.documents)
            }
          })
          setLoading1(false)
          setCount(getApplication.data.data.travellers_count);

          getApplication.data.data.travellers_informations.map(
            (value, index) => {
              if (value.status === "COMPLETED") {
                setCompletedCount(completedCount + 1)
              }
            }
          );
        } else if (getApplication.error) {
          console.log(getApplication.error);
          history.push(`/dashboard/my-applications/${id}/upload-other-docs`)
        }
      };
      application(item.value.token);









    }
    getWithExpiry("userData");

    if(props.details.value === undefined){
        history.push(`dashboard/my-applications`)
    }
    else{
        setFormId(props.details.value._id)
        const data1 = props.details.value;
        const one = [
          "_id",
          "employed",
          "documents",
          "created_at",
          "updated_at",
          "__v",
        ];
      
        const newdata = Object.keys(data1).reduce((object, key) => {
          if (!one.includes(key)) {
            object[key] = data1[key];
          }
          return object;
        }, {});
        newdata.status = "COMPLETED";
        newdata.wifes_name = "null";

        setNewData(newdata)
        setValue(data1)
    }
  }, []);


  const [value, setValue] = useState({profession: ""})

  const [loading, setLoading] = useState(true);

  let { id } = useParams();
  const history = useHistory();

  const [docs, setDocs] = useState([]);
  const [loading1, setLoading1] = useState(true);

  const [token, setToken] = useState("");
  const [loading2, setLoading2] = useState(false);

  const [count, setCount] = useState("");

  const [completedCount, setCompletedCount] = useState(0);

  const [travellers, setTravellers] = useState([]);

  const [formId, setFormId] = useState("")

  const [newData, setNewData] = useState("")

  console.log(value);



  const submit = () => {
    setLoading2(true);

    const submitApplication = async () => {
      const SubmitApp = await submitDetailsApi(id, token, newData, formId);

      if (SubmitApp.data) {
        console.log(SubmitApp.data);

        if (count === completedCount) {
          history.push(
            `/dashboard/my-applications/${id}/submitted-successfully`
          );
        } else {
          history.push(`/dashboard/my-applications/${id}/travellers`);
        }
        setLoading2(false);
      } else if (SubmitApp.error) {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="22" />
            &nbsp; {SubmitApp.error.message}
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setLoading2(false);
      }
    };
    submitApplication();
  };

  const submitLater = () => {
    console.log("Submit Later");
    history.push(`/dashboard/my-applications/${id}/travellers`);
  };

  return (
    <div>
      <h2 className={styles.head}>Review Application</h2>
      {/* {loading ? (
        <div className={styles.loader}>
            <div className="spinner-border" role="status"></div>
        </div>
      ):
      ( */}
      <>
        <div>
          <div className={styles.mainBox}>
            <div className={styles.box1FirstCont}>
              <p className={styles.badge}>1</p>
              <p className={styles.FirstText}>Passport Information</p>
            </div>
            <hr className={styles.line} />
            <div className={styles.inputsBox}>
              <div>
                <label for="passport-type" className={styles.label}>
                  Passport Type
                </label>
                <br />
                <span type="text" id="passport-type" className={styles.input}>
                  {value.passport_type}
                </span>
              </div>
              <div>
                <label for="Surname" className={styles.label}>
                  Surname<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span type="text" id="Surname" className={styles.input}>
                  {value.last_name}
                </span>
              </div>
              <div>
                <label for="Given-Name" className={styles.label}>
                  Given Name<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span type="text" id="Given-Name" className={styles.input}>
                  {value.given_name}
                </span>
              </div>
            </div>
            <div className={styles.inputsBox}>
              <div>
                <label for="Country-of-Birth" className={styles.label}>
                  Country of Birth<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span
                  type="text"
                  id="Country-of-Birth"
                  className={styles.input}
                >
                  {value.country_of_birth}
                </span>
              </div>
              <div>
                <label for="Date of Birth" className={styles.label}>
                  Date of Birth<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span className={styles.input2}>
                  <span
                    type="number"
                    className={styles.inputIn}
                    min="1"
                    max="31"
                    maxLength="2"
                  >
                    {new Date(value.date_of_birth).getDate() - 1}
                  </span>
                  <span
                    type="number"
                    className={styles.inputIn}
                    min="1"
                    max="12"
                    maxLength="2"
                  >
                    {new Date(value.date_of_birth).getMonth() + 1}
                  </span>
                  <span type="number" className={styles.inputIn2} maxLength="2">
                    {new Date(value.date_of_birth).getFullYear()}
                  </span>
                </span>
              </div>
              <div>
                <label for="Place of birth" className={styles.label}>
                  Place of birth<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span type="text" id="Place of birth" className={styles.input}>
                  {value.place_of_birth}
                </span>
              </div>
            </div>
            <div className={styles.inputsBox}>
              <div>
                <label for="Passport Number" className={styles.label}>
                  Passport Number<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span
                  type="text"
                  id="Passport Number"
                  type="text"
                  className={styles.input}
                >
                  {value.passport_number}
                </span>
              </div>
              <div>
                <label for="Passport Issuance Date" className={styles.label}>
                  Passport Issuance Date
                  <span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span className={styles.input2}>
                  <span
                    type="number"
                    className={styles.inputIn}
                    min="1"
                    max="31"
                    maxLength="2"
                  >
                    {new Date(value.passport_issuance_date).getDate() - 1}
                  </span>
                  <span
                    type="number"
                    className={styles.inputIn}
                    min="1"
                    max="12"
                    maxLength="2"
                  >
                    {new Date(value.passport_issuance_date).getMonth() + 1}
                  </span>
                  <span type="number" className={styles.inputIn2} maxLength="2">
                    {new Date(value.passport_issuance_date).getFullYear()}
                  </span>
                </span>
              </div>
              <div>
                <label for="Passport Expiry Date" className={styles.label}>
                  Passport Expiry Date
                  <span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span className={styles.input2}>
                  <span type="number" className={styles.inputIn}>
                    {new Date(value.passport_expiry_date).getDate() - 1}
                  </span>
                  <span type="number" className={styles.inputIn}>
                    {new Date(value.passport_expiry_date).getMonth() + 1}
                  </span>
                  <span type="number" className={styles.inputIn2}>
                    {new Date(value.passport_expiry_date).getFullYear()}
                  </span>
                </span>
              </div>
            </div>
            <div className={styles.inputsBox}>
              <div>
                <label for="Nationality" className={styles.label}>
                  Nationality<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span type="text" id="Nationality" className={styles.input}>
                  {value.nationality}
                </span>
              </div>
              <div>
                <label for="Passport Issuance Place" className={styles.label}>
                  Passport Issuance Place
                  <span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span
                  type="text"
                  id="Passport Issuance Place"
                  className={styles.input}
                >
                  {value.passport_issuance_place}
                </span>
              </div>
              <div>
                <label for="Sex" className={styles.label}>
                  Sex<span style={{ color: "#d84343" }}>*</span>
                </label>
                <br />
                <span type="text" id="Sex" className={styles.input}>
                  {value.gender}
                </span>
              </div>
            </div>
            {/* <div className={styles.btns}>
            <button className={styles.btn1} onClick={() => editPassportDetails()}>
              Edit Passport Details
            </button>
          </div> */}
          </div>
          <br />
          <div className={styles.mainBox2}>
            <div className={styles.box1FirstCont}>
              <p className={styles.badge}>2</p>
              <p className={styles.FirstText}>Other Information</p>
            </div>
            <hr className={styles.line} />
            <div className={styles.inputsBox}>
              <div className={styles.select}>
                <label for="Profession" className={styles.label}>
                  Marital Status
                </label>
                <br />

                <span className={styles.input}>{value.marital_status}</span>
              </div>
              <div className={styles.select}>
                <label for="Profession" className={styles.label}>
                  Profession
                </label>
                <br />
                <span className={styles.input}>
                  {value.profession.replace(/_/g, " ")}
                </span>
              </div>

              <div className={styles.select}>
                <label for="Religion" className={styles.label}>
                  Religion
                </label>
                <br />
                <span className={styles.input}>{value.religion}</span>
              </div>
            </div>

            <div className={styles.inputsBox}>
              {value.marital_status === "MARRIED" ? (
                value.gender === "MALE" ? (
                  <div>
                    <label for="Wife's Name" className={styles.label}>
                      Wife's Name
                    </label>
                    <br />
                    <span className={styles.input}>{value.spouse_name}</span>
                  </div>
                ) : value.gender === "FEMALE" ? (
                  <div>
                    <label for="Husband's Name" className={styles.label}>
                      Husband's Name
                    </label>
                    <br />
                    <span className={styles.input}>{value.spouse_name}</span>
                  </div>
                ) : null
              ) : null}

              <div>
                <label for="Mother's Name" className={styles.label}>
                  Mother's Name
                </label>
                <br />
                <span className={styles.input}>{value.mothers_name}</span>
              </div>
              <div>
                <label for="Father's Name" className={styles.label}>
                  Father's Name
                </label>
                <br />
                <span className={styles.input}>{value.fathers_name}</span>
              </div>
            </div>
            {/* <div className={styles.btns}>
            <button className={styles.btn1} onClick={() => editOtherDetails()}>
              Edit Other Details
            </button>
          </div> */}
          </div>
          <br />

          <div
            className={
              value.is_ticket_booked === "YES"
                ? styles.mainBox3
                : styles.mainBox3Diff
            }
          >
            <div className={styles.box1FirstCont}>
              <p className={styles.badge}>3</p>
              <p className={styles.FirstText}>Travel Information</p>
            </div>
            <hr className={styles.line} />
            <div className={styles.inputsBox1}>
              <div>
                <label
                  for="Have you booked your flight tickets?"
                  className={styles.label}
                >
                  Have you booked your flight tickets?
                </label>
                <br />
                <span>
                  <span>
                    <Radio
                      // onChange={() => {
                      //   setBooked("YES")
                      // }}
                      checked={value.is_ticket_booked === "YES"}
                      value="normal"
                      color="default"
                      name="Booked"
                      disabled={true}
                    />
                    Yes
                  </span>
                  <span className={styles.littleMar}>
                    <Radio
                      // onChange={() => {
                      //     setBooked("NO")
                      // }}
                      checked={value.is_ticket_booked === "NO"}
                      value="No"
                      color="default"
                      name="Booked"
                      disabled={true}
                    />
                    No
                  </span>
                </span>
              </div>
            </div>
            {value.is_ticket_booked === "YES" ? (
              <>
                <div className={styles.inputsBox}>
                  <div>
                    <label for="Departure City" className={styles.label}>
                      Departure City<span style={{ color: "#d84343" }}>*</span>
                    </label>
                    <br />
                    <span className={styles.input}>{value.departure_city}</span>
                  </div>
                  <div>
                    <label for="Arrival City" className={styles.label}>
                      Arrival City<span style={{ color: "#d84343" }}>*</span>
                    </label>
                    <br />
                    <span className={styles.input}>{value.arrival_city}</span>
                  </div>
                  <div>
                    <label
                      for="Departure Airline Name"
                      className={styles.label}
                    >
                      Departure Airline Name
                      <span style={{ color: "#d84343" }}>*</span>
                    </label>
                    <br />
                    <span className={styles.input}>
                      {value.departure_airline}
                    </span>
                  </div>
                </div>
                <div className={styles.inputsBox}>
                  <div>
                    <label for="Departure Date" className={styles.label}>
                      Departure Date<span style={{ color: "#d84343" }}>*</span>
                    </label>
                    <br />
                    <span className={styles.input2}>
                      <span className={styles.input2}>
                        <span type="number" className={styles.inputIn}>
                          {new Date(value.departure_date).getDate() - 1}
                        </span>
                        <span type="number" className={styles.inputIn}>
                          {new Date(value.departure_date).getMonth() + 1}
                        </span>
                        <span type="number" className={styles.inputIn2}>
                          {new Date(value.departure_date).getFullYear()}
                        </span>
                      </span>
                    </span>
                  </div>
                  <div>
                    <label for="Arrival Date" className={styles.label}>
                      Arrival Date<span style={{ color: "#d84343" }}>*</span>
                    </label>
                    <br />
                    <span className={styles.input2}>
                      <span type="number" className={styles.inputIn}>
                        {new Date(value.arrival_date).getDate() - 1}
                      </span>
                      <span type="number" className={styles.inputIn}>
                        {new Date(value.arrival_date).getMonth() + 1}
                      </span>
                      <span type="number" className={styles.inputIn2}>
                        {new Date(value.arrival_date).getFullYear()}
                      </span>
                    </span>
                  </div>
                </div>
              </>
            ) : null}
          </div>
          <br />
          <div className={styles.mainBox4}>
          <div className={styles.box1FirstCont}>
            <p className={styles.badge}>4</p>
            <p className={styles.FirstText}>Uploaded Documents</p>
          </div>
          <hr className={styles.line} />
          <div className={styles.container}>
            <h1 className={styles.attachmentHead}>Attachments:</h1>
  
            <div className={styles.documents}>
              {loading1 ? (
                <div className={styles.loader1}>
                  <div className="spinner-border" role="status"></div>
                </div>
              ) : (
                docs.map((value, index) => (
                  <div className={styles.document} key={index}>
                    <a href={value.link} target="_blank" rel="noopener">
                      <img
                        src={document}
                        alt="Documents"
                        className={styles.documentimage}
                      />
                    </a>
                    <a href={value.link} target="_blank" rel="noopener">
                      <h1 className={styles.documentName}>{value.name}</h1>
                    </a>
                  </div>
                ))
              )}
            </div>
          </div>
          
        </div>
<br />
        </div>
        <div className={styles.btnsCont}>
          <button className={styles.btn1} onClick={() => history.goBack()}>
            Go Back
          </button>

          <button className={styles.btn2} onClick={() => submit()}>
            {loading2 ? (
              <div className="spinner-border" role="status"></div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </>
      {/* )} */}
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(ReviewSavedMain);
